import { useState, useId } from 'react'
import { Props_SnippetAnimatedCards } from './AnimatedCards.props'
import { CompileMarkdown, CompileHeadingToSpan } from '../../../../Shared/AttraxTs/React/ReactSnippetMDCompiler'

const SnippetAnimatedCards = (props: Props_SnippetAnimatedCards) => {
    const { title, text, snippet, repeatable_entry } = props
    const [activeCard, setActiveCard] = useState<number | null>(null)
    const baseId = useId()
    const backgroundColorClass = `snippet-animated-cards--bg--${snippet.backgroundColor?.value}`

    const openCard = (index: number) => {
        setActiveCard(index)
    }

    return (
        <section className={`snippet-animated-cards ${backgroundColorClass}`}>
            <div className="snippet-animated-cards__container">
                <div className="snippet-animated-cards__header">
                    {title?.content?.value && (
                        <h2 className={`snippet-animated-cards__title${!title.visibility?.value ? ' accessible-heading' : ''}`}>
                            {CompileHeadingToSpan(title.content.value)}
                        </h2>
                    )}
                    {text?.content?.value && (
                        <div className="snippet-animated-cards__text">{CompileMarkdown(text.content.value)}</div>
                    )}
                </div>
                <div className="snippet-animated-cards__cards">
                    {repeatable_entry.map(({ image, imageAlt, cardTitle, cardText }, index: number) => {
                        const isActive = activeCard === index
                        return (
                            <article key={`${baseId}-${index}`} className={`snippet-animated-cards__card ${isActive ? 'snippet-animated-cards__card--active' : ''}`}>
                                {image?.value && (
                                    <img
                                        className="snippet-animated-cards__card-image"
                                        loading="lazy"
                                        src={image.value}
                                        alt={imageAlt?.value ? imageAlt.value : ''}
                                    />
                                )}
                                <div className="snippet-animated-cards__card-footer">
                                    {cardTitle?.value && (
                                        <h3 className="snippet-animated-cards__card-title" aria-hidden={isActive}>
                                            {CompileHeadingToSpan(cardTitle.value)}
                                        </h3>
                                    )}
                                    <button
                                        type="button"
                                        className={`snippet-animated-cards__toggle${isActive ? ' snippet-animated-cards__toggle--hidden' : ''}`}
                                        onClick={() => openCard(index)}
                                        tabIndex={isActive ? -1 : 0}
                                        aria-hidden={isActive}
                                    />
                                </div>
                                <div className={`snippet-animated-cards__overlay ${isActive ? 'snippet-animated-cards__overlay--active' : ''}`} aria-hidden={!isActive}>
                                    {cardText?.value && (
                                        <div className="snippet-animated-cards__overlay-content">
                                            <div className="snippet-animated-cards__overlay-text">{CompileMarkdown(cardText.value)}</div>
                                        </div>
                                    )}
                                </div>
                            </article>
                        )
                    })}
                </div>
            </div>
        </section>
    )
}

export default SnippetAnimatedCards
